import { FinancialUtils } from '@macs-frontend/web-macs/shared/utils/financial';
import { NgrxValueConverter } from 'ngrx-forms';

export const priceConverter: NgrxValueConverter<string | null, number | null> = {
  convertViewToStateValue(value: string | null) {
    if (value === null) {
      return 0;
    }
    return FinancialUtils.toCents(parseFloat(value));
  },
  convertStateToViewValue(value: number | null) {
    if (value === null) {
      return null;
    }

    // eslint-disable-next-line no-param-reassign
    value = FinancialUtils.fromCents(value, 2);

    return value !== 0 ? value.toString() : null;
  },
};
